import React from "react";
import { 
    FormControl,
    FormLabel, 
    RadioGroup, 
    FormControlLabel, 
    Radio 
} from '@mui/material';
import PaymentTypes from '../../../models/PaymentTypes';

class Payment extends React.Component<any,any> {

    componentDidMount() {
        this.props.fetchPaymentTypes(this.props.personalNr)
    }

    public render() {
        let types: JSX.Element[] = []
        let paymentTypes = [...this.props.paymentTypes]

        if (paymentTypes !== null) {
            types = (paymentTypes as PaymentTypes[]).map(x => {
                return <FormControlLabel
                    value={x.id.toString()}
                    disabled={x.id === 2 && this.props.isAdmin === true}
                    control={<Radio className='radioBlue' />}
                    label={x.paymentTypeName} 
                    key={x.id}/>
            })
        }

        return (

            <div className='card'>
                <div className='card-header'>
                    Zahlung
            </div>
                <div className='card-body'>

                    <FormControl  >
                        <FormLabel style={{ color: 'rgba(0, 0, 0, 0.54)' }}>Bitte wählen Sie die gewünschte Zahlungsart:</FormLabel>
                        <RadioGroup
                            name="paymentTypeId"
                            value={`${this.props.paymentTypeId}`}
                            onChange={this.props.change}
                            key={this.props.paymentTypeId}
                        >
                            {types}
                        </RadioGroup>
                    </FormControl>
                </div>
            </div>
        )
    }
}

export default Payment